export default "__VITE_ASSET__BY0QbB6i__"